(() => {
 const start = () => {
  document.querySelectorAll('[data-polish-reviews]').forEach(root => {
   if (root.dataset.polishReady) return;
   const gallery = root.querySelector('[data-polish-review-gallery]');
   const track = root.querySelector('[data-polish-review-track]');
   const allReviews = root.querySelector('[data-polish-all-reviews]');
   if (!gallery || !track || !allReviews) return;
   let visible = 0;
   track.querySelectorAll('[data-source-review]').forEach(card => {
    const source = allReviews.querySelector('[data-review-id="' + card.dataset.sourceReview + '"]');
    const body = source?.querySelector('.jdgm-carousel-item__review-body');
    const author = source?.querySelector('.jdgm-carousel-item__reviewer-name');
    const rating = source?.querySelector('.jdgm-carousel-item__review-rating');
    if (!body || !author || !rating) return;
    const quote = body.textContent.trim();
    card.querySelector('[data-review-quote]').textContent = '“' + quote + '”';
    card.querySelector('[data-review-author]').textContent = author.textContent.trim();
    const stars = card.querySelector('[data-review-stars]');
    const count = rating.querySelectorAll('.jdgm--on').length;
    stars.textContent = '★'.repeat(count);
    stars.setAttribute('aria-label', rating.getAttribute('aria-label') || String(count));
    card.hidden = false;
    visible++;
   });
   if (!visible) return;
   root.dataset.polishReady = 'true';
   gallery.hidden = false;
   allReviews.open = false;
   const previous = root.querySelector('[data-review-direction="-1"]');
   const next = root.querySelector('[data-review-direction="1"]');
   const update = () => {
    const max = track.scrollWidth - track.clientWidth;
    const position = Math.abs(track.scrollLeft);
    previous.disabled = position < 2;
    next.disabled = max - position < 2;
   };
   root.querySelectorAll('[data-review-direction]').forEach(button => button.addEventListener('click', () => {
    const card = track.querySelector('li:not([hidden])');
    if (!card) return;
    const stride = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
    track.scrollBy({left: stride * Number(button.dataset.reviewDirection), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
   }));
   track.addEventListener('scroll', update, {passive:true});
   new ResizeObserver(update).observe(track);
   allReviews.addEventListener('toggle', () => { if (allReviews.open) window.dispatchEvent(new Event('resize')); });
   update();
  });
  document.querySelectorAll('.polish-footer-group').forEach(group => {
   if (group.dataset.polishReady) return;
   group.dataset.polishReady = 'true';
   const media = matchMedia('(min-width: 990px)');
   const update = () => { group.open = media.matches; };
   media.addEventListener('change', update);
   group.addEventListener('toggle', () => { if (media.matches && !group.open) group.open = true; });
   update();
  });
  const policy = document.querySelector('.refinement-shipping .shopify-policy__body');
  if (policy && !policy.querySelector('.polish-policy-nav')) {
   const headings = [...policy.querySelectorAll('h2')];
   if (headings.length) {
    const nav = document.createElement('nav');
    nav.className = 'polish-policy-nav';
    nav.setAttribute('aria-label', policy.dataset.contentsLabel || 'Shipping policy sections');
    headings.forEach((heading, index) => {
     if (!heading.id) heading.id = 'delivery-section-' + index;
     const link = document.createElement('a');
     link.href = '#' + heading.id;
     link.textContent = heading.textContent;
     nav.append(link);
    });
    policy.prepend(nav);
   }
  }
 };
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
 document.addEventListener('shopify:section:load', start);
})();
